import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export type TariffCalculationRequest = {
  shiftTruckIds: number[];
  calculateBilling: boolean;
  calculatePayment: boolean;
  skipExistingAmounts: boolean;
};

/** ダイアログ側が使ってきた名前。実体は TariffCalculationRequest と同じ */
export type TariffCalculationParams = TariffCalculationRequest;

export type TariffCalculationResponse = {
  billingUpdatedCount: number;
  paymentUpdatedCount: number;
  skippedCount: number;
  /** 車両ごとの失敗。API はエラーがあるときだけ errors キーを付けるので、ここでは常に配列にする */
  errors: string[];
};

type TariffCalculationApiResponse = {
  billing_updated_count: number;
  payment_updated_count: number;
  skipped_count: number;
  errors?: string[];
};

const requestPath = '/api/v5/tariff_calculations/bulk';

const buildRequestData = (params: TariffCalculationRequest) => ({
  shift_truck_ids: params.shiftTruckIds,
  calculate_billing: params.calculateBilling,
  calculate_payment: params.calculatePayment,
  skip_existing_amounts: params.skipExistingAmounts,
});

export const transformTariffCalculationResponse = (
  data: TariffCalculationApiResponse,
): TariffCalculationResponse => ({
  billingUpdatedCount: data.billing_updated_count,
  paymentUpdatedCount: data.payment_updated_count,
  skippedCount: data.skipped_count,
  errors: data.errors ?? [],
});

export const useTariffCalculationMutation = () => useMutation({
  mutationFn: async (params: TariffCalculationRequest) => {
    const response = await axios.post<TariffCalculationApiResponse>(requestPath, buildRequestData(params));
    return transformTariffCalculationResponse(response.data);
  },
});
